import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import './App.css'


// Component
import Home from './Component/Home';
import Europe from './Component/Stock_europe';
import France from './Component/Stock_France';
import FranceToFrance from './Component/Stock_France/FranceToFrance';
import FranceHorsUE from './Component/Stock_France/FranceToHorsUE';
import FranceToUE from './Component/Stock_France/FranceToUE';
import OSS from './Component/OSS'
import SameCountry from './Component/Stock_europe/SameCountry';
import UEToHorsUE from './Component/Stock_europe/UEToHorsUE';
import HorsUE from './Component/Stock_HorsUE';
import DropShippingUE from './Component/Stock_HorsUE/DropShippingUE';
import MarketPlace from './Component/Stock_HorsUE/MarketPlace';
import Platform from './Component/Stock_HorsUE/Platform';
import IOSS from './Component/IOSS';
import OSSUE from './Component/OSS/OSSUE';
import HorsUEtoUE from './Component/Stock_HorsUE/HorsUEtoUE';
import UK from './Component/UK/UK';
import CustomsFees from './Component/UK/CustomsFees';
import VATUK from './Component/UK/VATUK';
import PlatformDropshipping from './Component/Stock_HorsUE/platformDropShipping';
import FranceToUELess10K from './Component/Stock_France/FranceToUELess10K';
import PlatformUK from './Component/UK/PlatformUK';
import UkWithPlatform from './Component/UK/UkWithPlatform';

function App() {
  return (
    <div id='Container'>
      <div id='App'>
        <BrowserRouter>
          <Switch>
            <Route exact path='/'>
              <Home />
            </Route>
            <Route exact path='/France'>
              <France />
            </Route>
            <Route exact path='/Europe'>
              <Europe />
            </Route>
            <Route exact path='/FranceToFrance'>
              <FranceToFrance />
            </Route>
            <Route exact path='/FranceToUE'>
              <FranceToUE />
            </Route>
            <Route exact path='/FranceToHorsUE'>
              <FranceHorsUE />
            </Route>
            <Route exact path='/OSS'>
              <OSS />
            </Route>
            <Route exact path='/SameCountry'>
              <SameCountry />
            </Route>
            <Route exact path='/UEToHorsUE'>
              <UEToHorsUE />
            </Route>
            <Route exact path='/Hors-UE'>
              <HorsUE />
            </Route>
            <Route exact path='/DropshippingUE'>
              <DropShippingUE />
            </Route>
            <Route exact path='/MarketPlace'>
              <MarketPlace />
            </Route>
            <Route exact path='/Platform'>
              <Platform />
            </Route>
            <Route exact path='/IOSS'>
              <IOSS />
            </Route>
            <Route exact path='/OSSUE'>
              <OSSUE />
            </Route>
            <Route exact path='/HorsUEtoUE'>
              <HorsUEtoUE />
            </Route>
            <Route exact path='/UEtoUK'>
              <UK />
            </Route>
            <Route exact path='/Douane'>
              <CustomsFees />
            </Route>
            <Route exact path='/VATUK'>
              <VATUK />
            </Route>
            <Route exact path='/PlatformDropshipping'>
              <PlatformDropshipping />
            </Route>
            <Route exact path='/FranceToUELessThan10K'>
              <FranceToUELess10K />
            </Route>
            <Route exact path='/PlatformUK'>
              <PlatformUK />
            </Route>
            <Route exact path='/UkWithPlatform'>
              <UkWithPlatform />
            </Route>
          </Switch>
        </BrowserRouter>
      </div>
    </div>
    
  );
}

export default App;
